import {promoPage} from "./common/common";
import JsUtil from "./util/js-util";
window.jsUtil = new JsUtil();

// jsUtil.status(".btn-coupon--1-2", "disabled");
// jsUtil.status(".btn-coupon--1-1", "remove");
//
// jsUtil.msgCallBack = (str)=>{
//     console.log(str)
// };
//
// $(".btn-coupon--1-1").on("click", function(){
//     jsUtil.message("본인 확인이 필요합니다.", "본인확인");
//     jsUtil.message("제재 계정은 이벤트에 참여할 수 없습니다.", "제재계정");
//     jsUtil.message("기존 유저가 클릭 시, \n 본 이벤트는 신규/복귀 유저만 참여할 수 있습니다.", "신규복귀");
// });
//
// jsUtil.confirmCallBack = (str, status)=>{
//     console.log(str, status)
// };
//
// $(".btn-coupon--2").on("click", function(){
//     jsUtil.confirm("대표 캐릭터는 변경이 불가능합니다.\n 해당 캐릭터를 선택하시겠습니까?", "selected");
// });

promoPage();